export default "__VITE_ASSET__I6xblXoK__"